import Vue from 'vue';
// import { datadogRum } from '@datadog/browser-rum';
import * as types from './mutation-types';

/* ============
 * Mutations for the auth module
 * ============
 *
 * The mutations that are available on the
 * account module.
 */

export default {
  [types.CHECK](state) {
    state.authenticated = !!localStorage.getItem('id_token');
    const hasUser = !!localStorage.getItem('currentUser');
    if (state.authenticated) {
      Vue.$http.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem('id_token')}`;
      if (hasUser) {
        const userInfor = JSON.parse(localStorage.getItem('currentUser'));
        // datadogRum.setUser({
        //   id: userInfor.user_id,
        //   name: userInfor.name,
        //   email: userInfor.email,
        //   phone: userInfor.phone,
        // });
      }
    }
  },

  [types.REGISTER]() {},

  [types.LOGIN](state, response) {
    state.authenticated = true;
    state.currentUser = response.profile;
    localStorage.setItem('currentUser', JSON.stringify(response.profile));
    localStorage.setItem('id_token', response.access);
    localStorage.setItem('refresh_token', response.refresh);
    Vue.$http.defaults.headers.common.Authorization = `Bearer ${response.access}`;
    // datadogRum.setUser({
    //   id: response.profile.user_id,
    //   name: response.profile.name,
    //   email: response.profile.email,
    //   phone: response.profile.phone,
    // });
  },

  [types.REFRESH](state, response) {
    localStorage.setItem('id_token', response.access);
    localStorage.setItem('refresh_token', response.refresh);
    Vue.$http.defaults.headers.common.Authorization = `Bearer ${response.access}`;
  },

  [types.LOGOUT](state) {
    state.authenticated = false;
    state.currentUser = null;
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('list-enum');
    localStorage.removeItem('tags');
    localStorage.removeItem('invoice_common_code');
    localStorage.removeItem('seller-setting-list');
    localStorage.removeItem('active-announcement-lines');
    localStorage.removeItem('startDateSynchronized');
    localStorage.removeItem('maxConnect');
    localStorage.removeItem('totalInvoices');
    sessionStorage.removeItem('isConnectTaxAccount');
    Vue.$http.defaults.headers.common.Authorization = '';
  },

  [types.UPDATE_COMPANY_INFO](state, response) {
    state.currentUser.company = response;
    localStorage.setItem('currentUser', JSON.stringify(state.currentUser));
  },

  [types.UPDATE_USER_PROFILE](state, response) {
    state.currentUser.name = response.name;
    state.currentUser.phone = response.phone;
    localStorage.setItem('currentUser', JSON.stringify(state.currentUser));
  },

  [types.UPDATE_LICENSE](state, response) {
    if (state.currentUser.company.service_status.lics.EINVOICE.capacity) {
      state.currentUser.company.service_status.lics.EINVOICE.capacity += response;
    } else {
      state.currentUser.company.service_status.lics.EINVOICE.capacity = response;
    }
    localStorage.setItem('currentUser', JSON.stringify(state.currentUser));
  },

  [types.UPDATE_E_INVOICE_ROLE](state, response) {
    state.currentUser.einvoicerole = response;
    localStorage.setItem('currentUser', JSON.stringify(state.currentUser));
  },

  [types.GET_SUBSCRIPTIONS_MONITOR](state, response) {
    const user = state.currentUser;
    if (
      user &&
      user.company &&
      user.company.company_id &&
      user.company.service_status &&
      user.company.service_status.lics &&
      user.company.service_status.lics.EINVOICE &&
      typeof user.company.service_status.lics.EINVOICE.capacity === 'number' &&
      Array.isArray(response) &&
      response.length > 0
    ) {
      const companyId = user.company.company_id;
      const newCapacity = response.reduce((sum, item) => {
        if (item.company_id && item.company_id.id === companyId && item.service === 'EINVOICE') {
          return sum + parseInt(item.capacity, 10);
        }
        return sum;
      }, 0);

      user.company.service_status.lics.EINVOICE.capacity = newCapacity;

      localStorage.setItem('currentUser', JSON.stringify(user));
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js